import React, { FC, useEffect, useState } from 'react';
import {
    Box,
    Typography,
    Accordion,
    AccordionSummary,
    AccordionDetails,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import FlashlogReports from './flashlog-reports';
import VIMSSFTPFilesReports from './vims-sftp-files';
import MultiAssetSearchReports from './multi-asset-search';
import { Header } from '../../components/header';
import { Time, User, Help } from '../../components/header/components';
import useStyles from './styles';
import { AppState } from '../../store';

type AccordionItem = { title: string; open: boolean; component: FC<{}> };
type AccordionData = { title: string; data: AccordionItem[] }[];


const LibraryAccordions: FC<{}> = () => {
    const classes = useStyles();
    const appPermissions = useSelector(
      (state: AppState) => state.entitlements?.authorizations?.appPermissions,
    );
    const hasFullAccess = appPermissions?.iot?.reports.includes('*');

const sections = [
    {
        title: '',
        data: hasFullAccess
          ? [
            { title: 'Flashlog Reports', open: false, component: FlashlogReports },
            { title: 'VIMS SFTP Files Reports', open: false, component: VIMSSFTPFilesReports },
            {
                title: 'Multi Asset Search Reports',
                open: false,
                component: MultiAssetSearchReports,
              },
            ]
          : [],
      },
    ];

    if (!hasFullAccess) {
      if (appPermissions?.iot?.reports.includes('flashLog')) {
        sections[0].data.push({
          title: 'Flashlog Reports',
          open: false,
          component: FlashlogReports,
        });
      }
      if (appPermissions?.iot?.reports.includes('vimsSFTPFiles')) {
        sections[0].data.push({
          title: 'VIMS SFTP Files Reports',
          open: false,
          component: VIMSSFTPFilesReports,
        });
      }
      if (appPermissions?.iot?.reports.includes('multiAssetSearch')) {
        sections[0].data.push({
          title: 'Multi Asset Search Reports',
          open: false,
          component: MultiAssetSearchReports,
        });
      }
    }
    const [accordionData, setAccordionData] = useState<AccordionData>(sections);
    const toggleOpen = (sectionIterator: number, componentIterator: number) => {
        const toggledCopy = [...accordionData];
        toggledCopy[sectionIterator].data[componentIterator].open = !accordionData[sectionIterator]
            .data[componentIterator].open;
        setAccordionData(toggledCopy);
    };
    const location = useLocation();

    useEffect(() => {
        setAccordionData(
            accordionData.map(accordion => ({
                ...accordion,
                data: accordion.data.map((data) => ({
                    ...data,
                    open: false
                }))
            })
            ));
    }, [location.pathname]);

    return (
        <>
            <Header title="REPORTS"
                headerComponents={[<Help userLink='/SitePages/Reports-Manual.aspx?promotedState=0' />,<Time suppressPopover />, <User />]}
            />
            <Box className={classes.scrollBox}>
                <div className={classes.accordions}>
                    {accordionData.map((section, sectionIterator) => (
                        <>
                            <Box>
                                <Typography variant="h6">{section.title}</Typography>
                            </Box>
                            {section.data.map((componentContainer, componentIterator) => (
                                <Accordion
                                    id={`${componentContainer.title}Panel`}
                                    expanded={componentContainer.open}
                                    onChange={() => toggleOpen(sectionIterator, componentIterator)}
                                >
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel-content"
                                        id="panel-header"
                                    >
                                        <Typography variant="h5">{componentContainer.title}</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        {componentContainer.open && <componentContainer.component />}
                                    </AccordionDetails>
                                </Accordion>
                            ))}
                        </>
                    ))}
                </div>
            </Box>
        </>
    );
};

export default LibraryAccordions;
